import { Size } from './types'

export const GrowingIconType = {
  Size
}

export { default } from './GrowingIcon'
